import { FilterParam } from '../types/filters.js';

const getAppConsistentParams = (searchString) => {
    const searchParams = new URLSearchParams(searchString);
    const newSearchParams = new URLSearchParams();
    Object.values(FilterParam).forEach((param) => {
        if (searchParams.get(param)) {
            newSearchParams.append(param, searchParams.get(param));
        }
    });
    return newSearchParams;
};

export { getAppConsistentParams };
//# sourceMappingURL=appUtils.js.map
